import { render } from "./DetailRow.vue?vue&type=template&id=24850a20&scoped=true"
import script from "./DetailRow.vue?vue&type=script&lang=js"
export * from "./DetailRow.vue?vue&type=script&lang=js"

import "./DetailRow.vue?vue&type=style&index=0&id=24850a20&scoped=true&lang=css"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24850a20"],['__file',"resources/js/Pages/Packages/DetailRow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24850a20"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24850a20', __exports__)) {
    console.log('reload')
    api.reload('24850a20', __exports__)
  }
  
  module.hot.accept("./DetailRow.vue?vue&type=template&id=24850a20&scoped=true", () => {
    console.log('re-render')
    api.rerender('24850a20', render)
  })

}


export default __exports__